<template>
	<v-btn @click="submit">
		<translate>Processed</translate>
	</v-btn>
</template>

<script>
import axios from 'axios';
import {
	inform, displayError,
} from 'laravel-front-library';
import {
	debounce,
} from 'lodash';

export default {
	name: 'ProcessDirectDebitFile',
	props: {
		'id': {
			type: Number,
			required: true
		}
	},

	methods: {
		/**
		 * Submit direct debit export file by id
		 *
		 * @returns {void}
		 */
		submit () {
			axios.post('/api/v0/directdebitexports/process', {
				id: this.id
			})
				.then(() => {
					inform(this.$gettext('Direct debit file processed successfully'));
					debounce(() => {
						window.location.reload();
					}, 1000)();
				})
				.catch(({
					response
				}) => {
					let message;

					if (response.data && response.data.message) {
						message = response.data.message;
					} else {
						message = this.$gettext('Something went wrong while marking the file as processed');
					}
					displayError(message);
				});
		},
	}
};
</script>

<style scoped>

</style>
